import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import ComingSoonPage from "@/pages/ComingSoonPage";
import OverviewPage from "@/pages/OverviewPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import PilotPage from "@/pages/PilotPage";
import DashboardPage from "@/pages/DashboardPage";
import WalkthroughPage from "@/pages/WalkthroughPage";
import FutureParticipationPage from "@/pages/FutureParticipationPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ComingSoonPage />} />
          <Route path="/overview" element={<OverviewPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/pilot" element={<PilotPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/walkthrough" element={<WalkthroughPage />} />
          <Route path="/future-infrastructure-participation" element={<FutureParticipationPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
